"use client";

import Link from "next/link";
import { capturePostHogEvent } from "@/lib/posthog-client";
import { POSTHOG_EVENTS, POSTHOG_SOURCE } from "@/lib/posthog-events";
import { useLanguage } from "@/lib/useLanguage";

export function AppDownloadBanner({ compact }: { compact?: boolean }) {
  const { t } = useLanguage();

  return (
    <div
      className={`flex flex-wrap items-center justify-between gap-3 rounded-xl border border-accent/30 bg-accent/10 px-4 py-3 ${
        compact ? "text-sm" : ""
      }`}
    >
      <p className="text-gray-800 dark:text-gray-200 font-medium">
        {t.product?.appBanner ?? "Get the full experience in the MenúHunter app"}
      </p>
      <Link
        href="/download"
        onClick={() =>
          capturePostHogEvent(POSTHOG_EVENTS.APP_DOWNLOAD_CTA_CLICKED, {
            source: POSTHOG_SOURCE,
          })
        }
        className="shrink-0 rounded-lg bg-accent px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-accentDark transition-colors"
      >
        {t.product?.getApp ?? "Get the app"}
      </Link>
    </div>
  );
}
